import './App.css'
import React, { useEffect, useState } from 'react'
import GridItem from './GridItem'

const apiBase = (process.env.REACT_APP_API_BASE ?? '').replace(/\/+$/, '')

function App () {
  const [data, setData] = useState([])
  const [analytics, setAnalytics] = useState({})
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchData () {
      try {
        const response = await fetch(`${apiBase}/api/get-rates`)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const { rates, analytics } = await response.json()
        setData(rates ?? [])
        setAnalytics(analytics ?? {})
      } catch (err) {
        console.error('Failed to fetch rates:', err)
        setError('Failed to load rates. Please refresh.')
      }
    }
    fetchData()
  }, [])

  return (
    <div className="App">
      {error && <div className="error-banner">{error}</div>}
      <div className="grid-container">
        {data.length
          ? data.map(item =>
            (<GridItem data={item} analytics={analytics} key={item.merchant}/>)
          )
          : (<GridItem data={{}} analytics={{}} key="loading" />)}
      </div>
    </div>
  )
}

export default App
